<template>
  <div class="plugin-chat-container">
    <!-- 返回按钮 -->
    <div class="back-button-container">
      <el-button 
        type="primary" 
        icon="el-icon-arrow-left" 
        @click="goBack"
        size="small"
        class="back-button"
      >
        返回
      </el-button>
    </div>
    
    <!-- 聊天内容 -->
    <div class="chat-content" v-if="isShowingChat">
      <editor-chat v-if="uiStore.viewCode === 1" :chatData="currentChatData"></editor-chat>
      <editor-friend v-if="uiStore.viewCode === 2" @startChat="handleStartChat"></editor-friend>
      <editor-group v-if="uiStore.viewCode === 3"></editor-group>
    </div>
    
    <!-- 好友详情内容 -->
    <div class="friend-content" v-if="isShowingFriend">
      <editor-friend :friendData="friendData" @startChat="handleStartChat"></editor-friend>
    </div>
  </div>
</template>
<script>
import EditorChat from "./EditorChatPlugin.vue";
import EditorFriend from "./EditorFriend.vue";
import EditorGroup from "./EditorGroup.vue";

export default {
  name: "PluginChat",
  components: {
    EditorChat,
    EditorFriend,
    EditorGroup,
  },
  props: {
    chatData: {
      type: Object,
      default: () => ({})
    },
    friendData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: [],
      currentMode: 'default', // 'default' | 'chat' | 'friend'
      currentChatData: null, // 当前聊天数据
    };
  },
  methods: {
    onTop(chatIdx) {
      this.$store.commit("moveTop", chatIdx);
    },
    // 返回到InboxPlugin视图
    goBack() {
      // 如果当前在聊天模式，返回到好友详情
      if (this.currentMode === 'chat' && this.friendData) {
        this.switchToFriendMode();
      } else {
        // 否则返回到收件箱
        this.$emit('backToInbox');
      }
    },
    // 处理开始聊天事件
    handleStartChat(chatData) {
      console.log('[PluginChat] 开始聊天:', chatData);
      this.currentChatData = chatData;
      this.currentMode = 'chat';
      // 设置UI状态为聊天模式
      this.$store.commit("changeViewCode", 1);
    },
    // 切换到好友模式
    switchToFriendMode() {
      console.log('[PluginChat] 切换到好友模式');
      this.currentMode = 'friend';
      this.currentChatData = null;
      // 设置UI状态为好友详情模式
      this.$store.commit("changeViewCode", 2);
    },
  },
  computed: {
		uiStore() {
			return this.$store.state.uiStore;
		},
    chatStore() {
      return this.$store.state.chatStore;
    },
    loading() {
      return this.chatStore.loadingGroupMsg || this.chatStore.loadingPrivateMsg;
    },
    // 判断是否显示聊天内容
    isShowingChat() {
      // 如果有传入的chatData且没有friendData，或者当前模式是chat
      return (this.chatData && Object.keys(this.chatData).length > 0 && !this.friendData) || 
             (this.currentMode === 'chat');
    },
    // 判断是否显示好友详情
    isShowingFriend() {
      // 如果有friendData且当前模式不是chat
      return this.friendData && Object.keys(this.friendData).length > 0 && this.currentMode !== 'chat';
    }
  },
  watch: {
    // 监听好友数据变化，设置UI状态
    friendData: {
      handler(newFriendData) {
        if (newFriendData && Object.keys(newFriendData).length > 0) {
          console.log('接收到好友数据:', newFriendData);
          this.currentMode = 'friend';
          this.currentChatData = null;
          // 设置UI状态为好友详情模式
          this.$store.commit("changeViewCode", 2);
          // 设置活跃好友
          this.$store.commit("setActiveFriend", newFriendData);
        }
      },
      immediate: true
    },
    // 监听聊天数据变化
    chatData: {
      handler(newChatData) {
        if (newChatData && Object.keys(newChatData).length > 0 && !this.friendData) {
          console.log('接收到聊天数据:', newChatData);
          this.currentMode = 'default';
          this.currentChatData = newChatData;
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.plugin-chat-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .back-button-container {
    padding: 10px;
    background: var(--im-color-primary-light-9);
    border-bottom: 1px solid #e4e7ed;
    
    .back-button {
      font-size: 14px;
    }
  }
  
  .chat-content, .friend-content {
    flex: 1;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.chat-page {
  .chat-list-box {
    display: flex;
    flex-direction: column;
    background: var(--im-background);

    .chat-list-header {
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 8px;
    }

    .chat-list-loading {
      height: 50px;
      background-color: #eee;

      .el-icon-loading {
        font-size: 24px;
        color: var(--im-text-color-light);
      }

      .el-loading-text {
        color: var(--im-text-color-light);
      }

      .chat-loading-box {
        height: 100%;
      }
    }

    .chat-list-items {
      flex: 1;
    }
  }
}
</style>
